import classnames, { Argument } from 'classnames';
import { twMerge } from 'tailwind-merge';

/**
 * Combines `classnames` and `tailwind-merge`:
 * - Accepts the same arguments as `classnames` (strings, arrays, objects, falsy values).
 * - Resolves conflicting Tailwind utility classes deterministically — the later class wins,
 *   without needing `!important` (`!`) overrides.
 *
 * @example
 * cn('justify-center', condition && 'justify-start') // → 'justify-start' wins when condition is true
 * cn('flex p-4', className) // → caller's className overrides defaults cleanly
 */
export const cn = (...args: Argument[]): string => twMerge(classnames(...args));
